
import React from 'react';
import { AppBar, Box, Toolbar, Container, Button } from "@mui/material";
import blueLogo from 'assets/images/blueLogo.svg'
import { getBranding } from 'config/tenantConfig'

const pages = ['Ride','Driver','More'];

function FAQHeader() {
  
  return (
    <AppBar position="static" className="bgColorBlue navAlign">
      <Container maxWidth="xl" className='h100 mobileResponsive'>
        <Toolbar disableGutters>
          <img src={getBranding().logo || blueLogo} alt='blueLogo' className='logoImage'/>  
          <Box sx={{ flexGrow: 1, display: { md: 'flex' ,justifyContent:'flex-start' } }}>
            {pages.map((page) => (
              <Button 
                className='font18 marginLeft20 fontNormal textCaptialize colorWhite'
                key={page}
                sx={{ my: {md: 3}, }}
              >
                {page}
              </Button>
            ))}
          </Box>
          <Box sx={{ flexGrow: 0, display: { md: 'flex' ,justifyContent:'end' } }}>
              <Button
                className='font18 fontNormal textCaptialize colorWhite'
                sx={{ my: {md: 1}, }}
              >
                Help
              </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default FAQHeader;